import { useContext, useEffect } from "react";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";
import { useSelector } from "react-redux";
import { getProductCategoriesSelector } from "../../../umbilical_hocs";
import { isElligibleToBookSelector } from "../../../selectors";
import _ from "lodash";
import { AuthEnvContext } from "../../../context";
import { useApoAuth } from "../../../hooks";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";

export const useNavBarGeneralHook = ({ setShowNavbar }) => {
  const { brand } = useContext(StyleTypeContext);

  const location = useLocation();

  const isInHomepage = location.pathname === "/";
  const isInHotelDetailsPageRocsBrand =
    location.pathname === "/hotel_details/" && brand === "rocs";
  const currentPagePath = location.pathname;

  const { t } = useContext(TranslationContext);

  const {
    languages,
    currencies,
    multi_currency,
    home_btn_url,
    product_types,
    elligibleToBook,
    endpoint,
    withPoints,
    main_logo,
  } = useSelector((state) => {
    const withPoints = state?.WebsiteMetadata?.metadata?.points_scheme ?? false;
    return {
      languages: state?.WebsiteMetadata?.metadata?.languages ?? [],
      currencies: state?.WebsiteMetadata?.metadata?.currencies ?? [],
      product_types: getProductCategoriesSelector(state),
      elligibleToBook: isElligibleToBookSelector(state),
      endpoint: state?.GuestProfile?.extProfile?.endpoint,
      multi_currency:
        (state?.WebsiteMetadata?.metadata?.currencies ?? []).length > 1,
      home_btn_url: state?.WebsiteMetadata?.metadata?.home_btn_url ?? "/",
      main_logo: state?.WebsiteMetadata?.metadata?.main_logo,
      withPoints,
    };
  });

  const authContext = useContext(AuthEnvContext);
  const withLogin = authContext.withAuth;
  const { isAuthenticated } = useApoAuth();
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    setShowNavbar(true);
  }, [location, brand]);

  return {
    isInHomepage,
    isInHotelDetailsPageRocsBrand,
    currentPagePath,
    languages,
    currencies,
    multi_currency,
    home_btn_url,
    product_types,
    elligibleToBook,
    endpoint,
    withLogin,
    withPoints,
    isAuthenticated,
    loginWithRedirect,
    t,
    main_logo,
  };
};
